<div class="claim-status_1842-46589">
  <div class="health-card_I1842-46589-1773-7329">
    <div class="container_I1842-46589-1773-7336">
      <div class="container_I1842-46589-1773-16318">
        <div class="container_I1842-46589-1773-16319">
          <div class="health-policy-name_I1842-46589-1773-16320">
            <span class="text-health-policy-name_I1842-46589-1773-16321">Claim ID : {{id}}</span>
            <!-- <span class="text-health-policy-id_I1842-46589-1773-16322">Hospitalization Type - {{claimDetails.reimbursementType}}</span> -->
          </div>
        </div>
        <div *ngIf="claimDetails.claimStatus!=='Closed' && claimDetails.claimStatus!=='Claim settled' && claimDetails.claimStatus!=='Repudiated'; else closed" class="active">Active</div>
        <ng-template #closed >
          <div class="closed">
            {{claimDetails.claimStatus === 'Repudiated' ? "Rejected" : "Closed"}}
          </div>
        </ng-template>
      </div>
      <div class="frame-1984078699_I1842-46589-1773-7342">
        <div class="container_I1842-46589-1773-7343">
          <div class="health-policy-sum-insured_I1842-46589-1773-7344">
            <span class="text-buy-now-pay-later_I1842-46589-1773-7345">Patient Name</span>
            <span class="text-buy-now-pay-later_I1842-46589-1773-7346"  *ngIf="isClaimDetailsLoaded; else shimmer">{{claimDetails.patientName}}</span>
          </div>
          <div class="health-policy-member-cover_I1842-46589-1773-7347">
            <span class="text-buy-now-pay-later_I1842-46589-1773-7348">Admission Date</span>
            <span class="text-buy-now-pay-later_I1842-46589-1773-7349"
              *ngIf="isClaimDetailsLoaded; else shimmer">{{claimDetails.dateAdmission | date }}</span>

            <ng-template #shimmer>
              <div class="shimmer-wrapper">
                <div class="shimmer primary"></div>
              </div>
            </ng-template>

          </div>
          <div class="health-policy-sum-insured_I1842-46589-1773-7350">
            <span class="text-buy-now-pay-later_I1842-46589-1773-7351">Claim Amount</span>
            <span class="text-buy-now-pay-later_I1842-46589-1773-7352"  *ngIf="isClaimDetailsLoaded; else shimmer"> {{claimDetails.claimAmt | currency:'INR':'symbol':'1.0-2':'en-IN'}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="frame-1984078722_I1842-46589-1773-7361"*ngIf="claimDetails.claimStatus!=='Closed' && claimDetails.claimStatus!=='Claim settled' && claimDetails.claimStatus!=='Repudiated'">
      <app-medium-cta [property1]="claimDetails.claimStatus==='Closed' ? 'Primary CTA_Large_Disable' : 'Primary CTA_Large_Active'"
        class="medium-cta_I1842-46589-1773-7364" (click)="redirectToUploadDocuments(id)"></app-medium-cta>
    </div>
  </div>
</div>